import { LoginState } from "global/LoginState";
import { Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

function PrivateRoute({ children }) {
  const isLoggedIn = useRecoilValue(LoginState);
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default PrivateRoute;
